// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { ApiResponse } from 'services/_api';
import { RecuperarAtendimentoIntegradorPPTRequest, Types } from './types';

export function recuperarAtendimentoIntegradorPPTRequest(
	token: string,
	payload: RecuperarAtendimentoIntegradorPPTRequest,
): ReducerActionRotaSP {
	return {
		type: Types.RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_REQUEST,
		payload,
		token,
	};
}
export function recuperarAtendimentoIntegradorPPTSuccess(
	payload: string,
): ReducerActionRotaSP {
	return {
		type: Types.RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_SUCCESS,
		payload,
	};
}
export function recuperarAtendimentoIntegradorPPTFailure(
	payload: ApiResponse,
): ReducerActionRotaSP {
	return {
		type: Types.RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_FAILURE,
		payload,
	};
}
export function recuperarAtendimentoIntegradorPPTClear(): ReducerActionRotaSP {
	return {
		type: Types.RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_CLEAR,
		payload: null,
	};
}
